/** Extrai só dígitos e corrige DDI brasileiro duplicado (ex.: 55+55 → 55). */
export function normalizePhoneDigits(phone: string | null | undefined): string {
  if (!phone) return "";
  let digits = phone.replace(/\D/g, "");
  // Malformação comum: "55+55 51 …" → dígitos "55555151…"
  if (digits.startsWith("5555") && digits.length > 12) {
    digits = digits.slice(0, 2) + digits.slice(4);
  }
  return digits;
}

/** Formata telefone brasileiro para exibição (padrão Integrations.tsx). */
export function formatPhoneForDisplay(phone: string | null | undefined): string {
  if (!phone) return "";
  const cleaned = normalizePhoneDigits(phone);
  if (!cleaned) return phone;

  // +55 (11) 99999-9999 — 13 dígitos com DDI
  if (cleaned.length === 13) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 9)}-${cleaned.slice(9)}`;
  }
  // +55 (11) 9999-9999 — 12 dígitos com DDI
  if (cleaned.length === 12) {
    return `+${cleaned.slice(0, 2)} (${cleaned.slice(2, 4)}) ${cleaned.slice(4, 8)}-${cleaned.slice(8)}`;
  }
  // (11) 99999-9999 — 11 dígitos sem DDI
  if (cleaned.length === 11) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
  }
  // (11) 9999-9999 — 10 dígitos sem DDI
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
  }
  return phone;
}

/** Formata números internacionais (EUA/Canadá e Brasil) para exibição na UI. */
export function formatInternationalPhoneForDisplay(phone: string | null | undefined): string {
  if (!phone) return "";
  const trimmed = phone.trim();
  const cleaned = normalizePhoneDigits(phone);
  if (!cleaned) return trimmed;

  // NANP (EUA/Canadá): +1 e 10 dígitos locais
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  if (cleaned.length === 10 && (trimmed.startsWith("+1") || /\b1[\s\-(]/.test(trimmed))) {
    return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  const br = formatPhoneForDisplay(cleaned);
  if (br && br !== cleaned && br !== phone) return br;

  if (trimmed.startsWith("+")) return trimmed.replace(/\s+/g, " ");
  if (cleaned.length > 6) return `+${cleaned}`;
  return trimmed;
}
